import axios from 'axios';

export class WebhookService {
  static async triggerCallback(url: string, data: any): Promise<void> {
    try {
      await axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 10000, 
      });
    } catch (error) {
      console.error('Webhook callback failed:', error);
      throw error;
    }
  }
} 